import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccountManagementComponent } from './account-management/account-management.component';
import { LoginComponent } from './login/login.component';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertModule } from 'ngx-bootstrap/alert';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AuthInterceptorService } from './auth-interceptor.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ChangePlansComponent } from './account-management/change-plans/change-plans.component';
import { SafeHtmlPipe } from './safeHtmlPipe';
import {AccountSettingsComponent} from './account-management/account-settings/account-settings.component';
import {BillingInformationComponent} from './account-management/billing-information/billing-information.component';
import {HibernateCancelComponent} from './account-management/hibernate-cancel/hibernate-cancel.component';
import {IntegrationsComponent} from './integrations/integrations.component';
import {HeaderMenuComponent} from './header-menu/header-menu.component';
import {DashboardComponent} from './dashboard/dashboard.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AccountManagementComponent,
    LoginComponent,
    ChangePlansComponent,
    AccountSettingsComponent,
    BillingInformationComponent,
    HibernateCancelComponent,
    IntegrationsComponent,
    HeaderMenuComponent,
    DashboardComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AlertModule,
    AccordionModule,
    TabsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SafeHtmlPipe,
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }, provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent],
})
export class AppModule {
}
